import React, { Component } from 'react'
import { database } from '../../firebase'
import { ref, child, push, update, query, orderByChild, equalTo, get } from 'firebase/database'
import { withRouter } from '../../withRouter'
import Title from '../components/Title'
import { ActionAdd } from '../components/Actions'
import { ButtonPrimary } from '../components/Buttons'
import Partidos from '../modules/Partidos'
import { GroupText, GroupNumber, GroupSwitch, GroupCustom, GroupSelect } from '../forms/Groups'
import { StatusSuccess, StatusError } from '../forms/Status'
import './Add.css'

class Add extends Component {
  constructor (props) {
    super(props)
    this.state = {
      modes: [],
      mode: '',
      fecha: '',
      actual: false,
      desde: '',
      hasta: '',
      rows: [],
      error: null,
      status: '',
      success: '',
      saving: false
    }
    this.keyCount = 0
    this.handleAdd = this.handleAdd.bind(this)
    this.handleDelete = this.handleDelete.bind(this)
    this.handleMode = this.handleMode.bind(this)
    this.handleFecha = this.handleFecha.bind(this)
    this.handleDesde = this.handleDesde.bind(this)
    this.handleHasta = this.handleHasta.bind(this)
    this.handleActual = this.handleActual.bind(this)
    this.handleLocal = this.handleLocal.bind(this)
    this.handleVisitante = this.handleVisitante.bind(this)
    this.handleSubmit = this.handleSubmit.bind(this)
    this.dbRef = ref(database, 'quinielas')
  }
  componentDidMount () {
    this.rows = [{
      local: '',
      visitante: '',
      id: this.keyCount++
    }]
    const modalidadesRef = query(child(this.dbRef, 'modalidades'), orderByChild('active'), equalTo(true))
    get(modalidadesRef)
      .then((snap) => {
        const modes = []
        snap.forEach((child) => {
          modes.push({
            value: child.key,
            label: child.val().titulo
          })
        })
        modes.sort((a, b) => a.label.localeCompare(b.label))
        this.setState({
          rows: this.rows,
          modes: modes
        })
      })
      .catch((err) => {
        console.error(err)
      })
  }
  handleAdd (ev) {
    ev.preventDefault()
    this.rows.push({
      local: '',
      visitante: '',
      id: this.keyCount++
    })
    this.setState({
      rows: this.rows
    })
  }
  handleDelete (ev, id) {
    ev.preventDefault()
    this.rows = this.rows.filter((row) => row.id !== id)
    this.setState({
      rows: this.rows,
      error: ''
    })
  }
  handleMode (ev) {
    this.setState({
      mode: ev.target.value,
      status: '',
      error: null
    })
  }
  handleFecha (ev) {
    this.setState({
      fecha: ev.target.value,
      status: '',
      error: null
    })
  }
  handleActual (ev) {
    this.setState((prevState) => ({
      actual: !prevState.actual
    }))
  }
  handleDesde (ev) {
    this.setState({
      desde: ev.target.value,
      status: '',
      error: null
    })
  }
  handleHasta (ev) {
    this.setState({
      hasta: ev.target.value,
      status: '',
      error: null
    })
  }
  handleLocal (nombre, id, index) {
    this.rows[index].local = nombre
    this.rows[index].localId = id
    this.rows[index].error = false
    this.setState({
      rows: this.rows,
      status: '',
      error: null
    })
  }
  handleVisitante (nombre, id, index) {
    this.rows[index].visitante = nombre
    this.rows[index].visitanteId = id
    this.rows[index].error = false
    this.setState({
      rows: this.rows,
      status: '',
      error: null
    })
  }
  handleSubmit (ev) {
    ev.preventDefault()
    if (this.state.mode === '') {
      this.setState({
        error: 'mode',
        status: 'No olvides seleccinar una modalidad para esta quiniela.'
      })
    } else if (this.state.fecha === '') {
      this.setState({
        error: 'fecha',
        status: 'No olvides definir la fecha de esta quiniela.'
      })
    } else if (this.state.desde === '') {
      this.setState({
        error: 'desde',
        status: 'Necesitas especificar el inicio de la jornada.'
      })
    } else if (this.state.hasta === '') {
      this.setState({
        error: 'hasta',
        status: 'Necesitas especificar el cierre de la jornada.'
      })
    } else {
      const rowsLength = this.rows.length
      let count = 0
      this.rows.forEach((row, index) => {
        if (row.local === '' || row.visitante === '') {
          this.rows[index].error = true
          this.setState({
            rows: this.rows,
            error: true,
            status: 'No olvides definir los equipos, este debe ser válido de la lista.'
          })
          return
        }
        count++
      })
      if (count >= rowsLength) {
        this.setState({
          saving: true
        })
        const newKey = push(child(this.dbRef, 'index/' + this.state.mode)).key
        const partidos = this.rows.map((row) => ({
          local: row.local,
          localId: row.localId,
          visitante: row.visitante,
          visitanteId: row.visitanteId
        }))
        const index = {
          fecha: this.state.fecha,
          current: this.state.actual,
          desde: Number(this.state.desde),
          hasta: Number(this.state.hasta),
          active: true
        }
        const updates = {}
        updates['/partidos/' + this.state.mode + '/' + newKey] = partidos
        updates['/index/' + this.state.mode + '/' + newKey] = index
        update(this.dbRef, updates)
          .then(() => {
            this.setState({
              success: 'Quiniela guardada correctamente.'
            })
            setTimeout(() => this.props.history.push('/'), 2000)
          })
          .catch((err) => {
            this.setState({
              saving: false,
              status: err,
              error: true
            })
          })
      }
    }
  }
  render () {
    return (
      <div className='add'>
        <Title title='Crear quiniela' />
        <div className='add__content'>
          <form>
            <div className='add__content__header'>
              <h3>Crea una nueva quiniela</h3>
            </div>
            <div className='add__content__body'>
              <GroupSelect
                label='Modalidad'
                placeholder='Selecciona una modalidad para esta quiniela'
                value={this.state.mode}
                onChange={this.handleMode}
                options={this.state.modes}
                error={this.state.error === 'cat'}
              />
              <GroupText
                label='Fecha'
                placeholder='Fecha para identificar esta quiniela'
                value={this.state.fecha}
                onChange={this.handleFecha}
                error={this.state.error === 'fecha'}
                lg
              />
              <GroupNumber
                label='Inicio de la jornada'
                placeholder='Fecha y hora en milisegundos del inicio.'
                value={this.state.desde}
                onChange={this.handleDesde}
                error={this.state.error === 'desde'}
                lg
              />
              <GroupNumber
                label='Cierre de la jornada'
                placeholder='Fecha y hora en milisegundos del cierre.'
                value={this.state.hasta}
                onChange={this.handleHasta}
                error={this.state.error === 'hasta'}
                lg
              />
              <GroupSwitch
                label='Actual'
                value={this.state.actual}
                onChange={this.handleActual}
              />
              <GroupCustom
                label='Partidos'
              >
                {this.state.rows.map((row, index) => (
                  <Partidos
                    {...row}
                    key={row.id}
                    n={index}
                    handleDelete={this.handleDelete}
                    handleLocal={this.handleLocal}
                    handleVisitante={this.handleVisitante}
                    error={row.error}
                  />
                ))}
                <ActionAdd onClick={this.handleAdd} />
              </GroupCustom>
            </div>
            <div className='add__content__footer'>
              <div className='row'>
                <div className='col-sm-10 col-sm-push-2'>
                  <div className='add__content__footer__row'>
                    <ButtonPrimary
                      onClick={this.handleSubmit}
                      label='Guardar quiniela'
                      loading={this.state.saving}
                      type='submit'
                    />
                    {this.state.error && <StatusError>{this.state.status}</StatusError>}
                    {this.state.success && <StatusSuccess>{this.state.success}</StatusSuccess>}
                  </div>
                </div>
              </div>
            </div>
          </form>
        </div>
      </div>
    )
  }
}

export default withRouter(Add)
